import { CModal } from './CModal.js';
import { CModalBody } from './CModalBody.js';
import { CModalFooter } from './CModalFooter.js';
import { CModalHeader } from './CModalHeader.js';
import { CModalTitle } from './CModalTitle.js';

const CModalPlugin = {
    install: (app) => {
        app.component(CModal.name, CModal);
        app.component(CModalBody.name, CModalBody);
        app.component(CModalFooter.name, CModalFooter);
        app.component(CModalHeader.name, CModalHeader);
        app.component(CModalTitle.name, CModalTitle);
    },
};

export { CModal, CModalBody, CModalFooter, CModalHeader, CModalPlugin, CModalTitle };
//# sourceMappingURL=index.js.map
